import { Fragment } from 'react';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedCurrencyValue } from '@mews/framework';
import { getCurrencyValue, getChargedCurrencyAmount, getAccountingCurrencyAmount, MaybeAmount } from './currencyAmount';

interface ConvertedCurrencyValueProps {
    amount: MaybeAmount;
    net?: boolean;
    shouldShowAccountingCurrencyAmount?: boolean;
}

export const ConvertedCurrencyValue = ({
    amount,
    net = false,
    shouldShowAccountingCurrencyAmount = false,
}: ConvertedCurrencyValueProps) => {
    const sourceAmount = shouldShowAccountingCurrencyAmount
        ? getAccountingCurrencyAmount(amount)
        : getChargedCurrencyAmount(amount);

    return (
        <span>
            {sourceAmount && (
                <Fragment>
                    <LocalizedCurrencyValue value={getCurrencyValue({ amount: sourceAmount, net })} />
                    {` ${UnicodeEntity.RightwardsArrow} `}
                </Fragment>
            )}
            {amount && <LocalizedCurrencyValue value={getCurrencyValue({ amount, net })} />}
        </span>
    );
};
